import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  formatCurrency,
  formatHour,
  formatInteger,
  formatPercent,
} from './fnbAnalyticsUtils'

function KpiCard({ title, value, subtitle }) {
  return (
    <Card body className="card--xs card-with-border fnb-kpi-card">
      <p className="fnb-kpi-card__label">{title}</p>
      <p className="fnb-kpi-card__value">{value}</p>
      {subtitle ? <p className="fnb-kpi-card__subtitle">{subtitle}</p> : null}
    </Card>
  )
}

export default function FnbAnalyticsSummary({
  kpis,
  topItemName,
  snapshotDate,
}) {
  if (!kpis) return null

  return (
    <div className="fnb-analytics-summary">
      <div className="d-flex flex-wrap justify-content-between align-items-baseline gap-2 mb-3">
        <h2 className="h5 mb-0">Overview</h2>
        {snapshotDate ? (
          <span className="small text-muted">
            Snapshot: {new Date(snapshotDate).toLocaleDateString()}
          </span>
        ) : null}
      </div>
      <Row className="g-3">
        <Col sm={6} xl={3}>
          <KpiCard
            title="Gross Revenue"
            value={formatCurrency(kpis.grossRevenue)}
            subtitle={`Net ${formatCurrency(kpis.netRevenue)}`}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Orders"
            value={formatInteger(kpis.orderCount)}
            subtitle={`${formatInteger(kpis.itemCount)} items sold`}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Avg Order Value"
            value={formatCurrency(kpis.avgOrderValue)}
            subtitle={`${formatCurrency(kpis.avgSpendPerFan)} avg spend per fan`}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="F&B Attach Rate"
            value={formatPercent(kpis.attachRate)}
            subtitle={`${formatCurrency(kpis.revenuePerCheckedInFan)} per checked-in fan`}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Checked In"
            value={formatInteger(kpis.checkedInCount)}
            subtitle={`${formatInteger(kpis.ticketsSold)} tickets sold`}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Discounts"
            value={formatCurrency(kpis.discounts)}
            subtitle={`${formatCurrency(kpis.refunds)} refunded`}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Peak Hour"
            value={formatHour(kpis.peakHour)}
            subtitle="Highest order volume"
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Top Seller"
            value={topItemName || '—'}
            subtitle={
              kpis.topItemId ? `Item #${kpis.topItemId}` : 'No item data yet'
            }
          />
        </Col>
      </Row>
    </div>
  )
}
